<template>
    <BannerAbstract class="banner-welcome">

        <template #title>
            Welcome Aboard
        </template>
        <template #message>
            <i>Thank you</i> for joining us on our journey to make 3D modeling
            <i>child's play.</i> Get started by either creating <i>your own 3D models,</i> 
            or modifying <i>your existing models.</i>
        </template>

    </BannerAbstract>
</template>

<script>
import BannerAbstract from '@/components/common/banner/BannerAbstract.vue'

export default {
    name: 'BannerWelcome',
    components: {
        BannerAbstract
    }
}
</script>